module.exports = __webpack_public_path__ + "img/icon-high.a4fedfab.svg";